import React from 'react';
import {isInteger} from "../util/PaymentUtils";
import {TextField} from "@mui/material";
import {FC} from "react";

interface SimplePercentageFieldProps {
  id?: string | undefined,
  fullWidth?: boolean | undefined,
  label: string | undefined,
  name: string | undefined,
  placeholder?: string | undefined,
  max?: number,
  min?: number,
  onChange: (event: React.ChangeEvent<HTMLInputElement>, parsedValue: Number) => void,
  required?: boolean,
  value: string,
  helperText?: string
}

const SimplePercentageField: FC<SimplePercentageFieldProps> = ({
                                                                 id,
                                                                 fullWidth,
                                                                 label,
                                                                 max,
                                                                 min,
                                                                 name,
                                                                 onChange,
                                                                 placeholder,
                                                                 helperText,
                                                                 required,
                                                                 value,
                                                               }: SimplePercentageFieldProps) => {

  const valueInRange = (value: number, min?: number, max?: number): boolean => {
    if (min !== undefined && value < min) return false;
    return !(max !== undefined && value > max);
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (!value.length) return;
    const parsedValue = parseInt(value);
    if (!isInteger(value) || !valueInRange(parsedValue, min, max)) {
      return;
    }
    onChange(event, parsedValue);
  };

  return <TextField
    id={id}
    fullWidth={fullWidth}
    label={label}
    name={name}
    onChange={handleChange}
    placeholder={placeholder}
    required={required}
    variant={'standard'}
    value={value}
    helperText={helperText}
  />;
};

export default SimplePercentageField;
